import React, { useEffect, useState } from "react";
import { RouterProvider } from "react-router-dom";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";

import { initI18n } from "@/i18n/init";
import enCommon from "@/i18n/locales/en/common.json";
import { SafeProvider } from "@/safe/SafeContext";
import { WatchedSafeProvider } from "@/safe/WatchedSafeContext";
import { AppPreferencesProvider } from "@/app/preferences/AppPreferencesContext";
import { router } from "@/app/routes";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 15_000,
      retry: 1,
      refetchOnWindowFocus: false
    }
  }
});

export function App() {
  const [i18nReady, setI18nReady] = useState(false);
  const loadingLabel = enCommon["app.loading"] ?? "Loading…";

  useEffect(() => {
    void initI18n().then(() => setI18nReady(true));
  }, []);

  if (!i18nReady) {
    return (
      <div className="tw:flex tw:min-h-screen tw:items-center tw:justify-center tw:bg-iron-950 tw:text-iron-50">
        <div className="tw:text-sm tw:text-iron-300">{loadingLabel}</div>
      </div>
    );
  }

  return (
    <QueryClientProvider client={queryClient}>
      <AppPreferencesProvider>
        <SafeProvider>
          <WatchedSafeProvider>
            <RouterProvider router={router} />
          </WatchedSafeProvider>
        </SafeProvider>
      </AppPreferencesProvider>
    </QueryClientProvider>
  );
}
